import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ColumnMode } from '@swimlane/ngx-datatable';
import { DeviceService } from 'app/services/models/device.service';
import { BlockUI, NgBlockUI } from 'ng-block-ui';

@Component({
  selector: 'app-device-detail',
  templateUrl: './device-detail.component.html',
  styleUrls: ['./device-detail.component.scss'],
  encapsulation:ViewEncapsulation.None
})
export class DeviceDetailComponent implements OnInit {
  @BlockUI('section-block') blockUI: NgBlockUI;
  public contentHeader;

  device: any;

  rows: any;
  public pageBasic = 1;
  public selectedSize = 5;
  public basicSelectedOption: number = 5;
  public searchValue = '';
  totalCount: Number = 0;
  public ColumnMode = ColumnMode;
  
  constructor(
    private deviceSerivce: DeviceService,
    private activatedRouter: ActivatedRoute,
    private modalService:NgbModal) { }

  ngOnInit() {
    this.contentHeader = {
      headerTitle: 'Cihazlar',
      actionButton: true,
      breadcrumb: {
        type: '',
        links: [
          {
            name: 'Cihaz Listesi',
            isLink: true,
            link: 'device'
          },
          {
            name: 'Cihaz Detayı',
            isLink: false,
          },
        ]
      }
    }
    this.activatedRouter.params.subscribe(async params => {
      let id = params['id'];
      await this.getByIdDevice(id);
    })
    
  }

  async getByIdDevice(id) {
    this.blockUI.start("Cihaz detayı yükleniyor...")
    const data = await this.deviceSerivce.getByIdDevice(id);
    console.log(data);
    this.device = data;
    this.blockUI.stop();
  }
}
